import classNames from 'classnames';
import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { KeyboardKey } from '../../types';
import PauseIcon from './assets/pause';
import PlayIcon from './assets/play';
import { classes } from './PlayPause.st.css';
var PlayPause = function (props) {
    var _a;
    return (React.createElement("button", { className: classNames(classes.button, (_a = {}, _a[classes.disabled] = props.disabled, _a), props.className), "data-hook": props.dataHook, "aria-label": "Play", "aria-pressed": props.context.isPlaying ? 'true' : 'false', type: "button", onClick: props.onClick || props.context.togglePlay, onKeyDown: function (e) {
            if (e.key === KeyboardKey.Space) {
                return;
            }
            props.context.handleKeyDown(e);
        }, disabled: props.disabled }, props.isFocused &&
        (props.context.isPlaying || props.context.isPlayingInterrupted)
        ? props.iconPause
        : props.iconPlay));
};
PlayPause.displayName = 'PlayPause';
PlayPause.defaultProps = {
    className: '',
    dataHook: '',
    iconPlay: React.createElement(PlayIcon, null),
    iconPause: React.createElement(PauseIcon, null),
    disabled: false,
    isFocused: true,
};
export default withPlaybackContext(PlayPause);
//# sourceMappingURL=PlayPause.js.map